import { PreloadedEvent } from 'common/event-handling/events';
import eventBus from '../../event-handling/event-bus.model';
import { BasePreloadingStore } from './BasePreloadingStore';

export class PreloadingStore extends BasePreloadingStore {
  private _subscriptionId: string | null = null;

  constructor() {
    super();
    this._subscriptionId = eventBus.subscribe(PreloadedEvent, _ => {
      this.preloaded();
      eventBus.unsubscribe(this._subscriptionId!);
    });
  }
}
